/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * request body of POST prtimes_media_lists/restore
 * @export
 * @interface RestorePrtimesMediaListsRequest
 */
export interface RestorePrtimesMediaListsRequest {
    /**
     * メディアリストIDのリスト
     * @type {Array<number>}
     * @memberof RestorePrtimesMediaListsRequest
     */
    mediaListIds: Array<number>;
}

export function RestorePrtimesMediaListsRequestFromJSON(json: any): RestorePrtimesMediaListsRequest {
    return RestorePrtimesMediaListsRequestFromJSONTyped(json, false);
}

export function RestorePrtimesMediaListsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestorePrtimesMediaListsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListIds': json['media_list_ids'],
    };
}

export function RestorePrtimesMediaListsRequestToJSON(value?: RestorePrtimesMediaListsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_ids': value.mediaListIds,
    };
}

